<template>
  <div style="width: 100%;height: 100%;" class="body3">
    <div class="all">
      <div class="main">
        <div class="top_bg2">
          <headers pageType="suggestIndex"></headers>
          <div class="position">
            <div class="wraper"><p><a href="javascript:void(0)" style="color:#888888" @click="urlTo('home')">首页</a> / <span style="color:#2e2e2e">{{tempTitle}}</span></p></div>
          </div>
        </div>
        <div class="fixed">
          <fixedDiv></fixedDiv>
        </div>

        <div class="wraper">
          <div class="advice">
            <h2 class="tit8 line_bottom"><span><img src="../../../static/images/guide_sign8.png">{{tempTitle}}</span><em><img src="../../../static/images/required.png">为必填项</em></h2>
            <dl class="advice_tips">
              <dt>温馨提示</dt>
              <dd>1.您可以就政策法规、办事程序、收费标准等事项提出咨询，建言献策，投诉。</dd>
              <dd>2.为了您的留言得到及时有效处理和回应，请填写个人真实信息，并减少重复留言。</dd>
              <dd>3.本栏目答复是一种指导性意见，不具有法定效力。</dd>
              <dd>4.我们会及时回复您的留言，感谢您对我们工作的支持！</dd>
            </dl>
            <el-form  :rules="rules" :model="ruleForm" label-width="100px" ref="ruleForm" class="demo-ruleForm">
            <table width="90%" border="0" cellspacing="0" cellpadding="0" class="advice_tab">
              <tr v-if="partyYes">
                <td style="width: 202px;">
                  <el-form-item  label="受理单位" prop="selectedRegions">
                  <el-cascader v-model="selectedRegion" :props="props" :show-all-levels="false"   @change="onSelectedRegion" placeholder="请选择受理单位" clearable style="width: 200px;"></el-cascader>
                  </el-form-item>
                </td>
                <td style="width: 202px;">
                  <!--<el-form-item  label="受理单位" prop="selecteddepartOption">-->
                    <!--<el-select v-model="ruleForm.selecteddepartOption" placeholder="请选择受理单位" style="width:200px">-->
                      <!--<el-option-->
                        <!--v-for="(item,index) in departOption"-->
                        <!--:label="item.label"-->
                        <!--:value="item.value"-->
                        <!--:key="index">-->
                      <!--</el-option>-->
                    <!--</el-select>-->
                  <!--</el-form-item>-->
                  <el-form-item  :label="navTitle+'类别'" prop="types">
                    <el-select v-model="ruleForm.types" placeholder="请选择" style="width:200px">
                      <el-option
                        v-for="(item,index) in adviceType"
                        :label="item.label"
                        :value="item.value"
                        :key="index">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </td>
                <td>

                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-form-item  :label="navTitle+'标题'" prop="theTitle">
                  <el-input  v-model="ruleForm.theTitle" placeholder="请输入标题" style="width: 804px;" maxlength="48"></el-input>
                  </el-form-item>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-form-item  :label="navTitle+'内容'" prop="textarea">
                  <el-input
                  style="width: 804px;"
                  type="textarea"
                  :rows="4"
                  placeholder="请输入内容"
                  maxlength="350"
                  v-model="ruleForm.textarea">
                </el-input>
                  </el-form-item></td>
              </tr>
              <tr>
                <td colspan="3">
                  <div style="display: flex;justify-content: left;">


                    <el-form-item  :label="navTitle+'类别'" prop="types"  v-if="!partyYes">
                      <el-select v-model="ruleForm.types" placeholder="请选择" style="width:200px">
                        <el-option
                          v-for="(item,index) in adviceType"
                          :label="item.label"
                          :value="item.value"
                          :key="index">
                        </el-option>
                      </el-select>
                    </el-form-item></div>
                </td>
              </tr>
              <tr>
                <td colspan="3" class="enclosuer" >
                  <el-form-item  label="附件资料">
                  <!--<el-upload-->
                    <!--v-model="pictureList"-->
                    <!--action="#"-->
                    <!--list-type="picture-card"-->
                    <!--:http-request="afterReadOne"-->
                    <!--:on-remove="deleteone">-->
                    <!--<i class="el-icon-plus"></i>-->
                  <!--</el-upload>-->
                  <!--<el-dialog :visible.sync="dialogVisible">-->
                    <!--<img width="100%" :src="dialogImageUrl" alt="">-->
                  <!--</el-dialog>-->
                    <el-upload
                      class="upload-demo"
                      action="#"
                      :before-upload="beforeUpload"
                      :http-request="afterReadOne"
                      :on-remove="deleteone"
                      :file-list="fileList" style="width: 70%;">
                      <el-button size="small" type="primary">点击上传</el-button>
                    </el-upload>
                  </el-form-item>

                </td>
              </tr>
              <tr >
                <td style="font-size:15px;text-align: left;text-align: center;" colspan="3">
                  <div style="display: flex;justify-content: left;align-items: center">
                    <el-form-item  :label="navTitle+'人姓名'" prop="name">
                      <el-input v-model="ruleForm.name" placeholder="请输入" maxlength="10" style="width:200px"></el-input>
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr >
                <td style="font-size:15px;text-align: left;text-align: center;" colspan="3">
                  <div style="display: flex;justify-content: left;align-items: center">
                    <el-form-item  label="联系电话" prop="phone">
                      <el-input v-model="ruleForm.phone" placeholder="请输入" maxlength="11" style="width:200px"></el-input>
                    </el-form-item>
                  </div>
                </td>
              </tr>
              <tr >
                <td style="font-size:15px;text-align: left;text-align: center;" colspan="3">
                  <div style="display: flex;justify-content: left;align-items: center">
                    <el-form-item  label="短信校验码" prop="smsCode">
                      <el-input v-model="ruleForm.smsCode" placeholder="请输入" style="width:200px"></el-input>
                    </el-form-item>
                    <el-link type="primary" v-bind:disabled="smsIsDisabled" v-on:click="getSmsCode"  class="code" style="line-height: 25px;margin-bottom: 22px;margin-left: 5px;">{{smsText}}</el-link>

                  </div>
                </td>
              </tr>
              <!--<tr >-->
                <!--<td style="font-size:15px;text-align: left;text-align: center;" colspan="3">-->
                  <!--<div style="display: flex;justify-content: left;align-items: center">-->
                    <!--<el-form-item  label="验证码" prop="verifyCode">-->
                      <!--<el-input v-model="ruleForm.verifyCode" placeholder="请输入" style="width:200px"></el-input>-->
                    <!--</el-form-item>-->
                  <!--<img alt="验证码" :src="vImg" @click="getVerifyCode" style="width:100px;height: 42px;margin-bottom: 22px;-->
    <!--margin-left: 5px;">-->

                  <!--</div>-->
                <!--</td>-->
              <!--</tr>-->
              <tr>
                <td colspan="3"  >
                  <el-button type="primary" @click="save" style=" width: 120px;
    margin-left: 100px;" :disabled="disableds">提交</el-button>
                </td>
              </tr>
            </table>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div style="line-height: 35px;">
      <el-dialog :before-close="handleDialogClose" :visible.sync="showClause" width="600px" >
        <div style="text-align: center;font-size: 18px;margin-top: -30px;">{{this.cTitle}}</div>
        <div style="font-size: 14px;margin-left: 40px;margin-right: 35px;"><p v-html="this.cContent">{{this.cContent}}</p></div>
        <div style="margin-top: 30px;margin-left: 420px">
          <el-button type="primary" @click="clauseClose" >我已详细阅读</el-button>
        </div>
      </el-dialog>
    </div>
    <div class="clear"></div>
    <footers></footers>

  </div>
</template>

<script>
  import headers from "../../components/Headers";
  import fixedDiv from "../../components/FixedDiv";
  import footers from "../../components/Footer";

  export default {
    name: "suggests",
    components:{
      headers,fixedDiv,footers
    },

    data() {
      let _self=this;
      return {
        disableds:false,
        showClause:false,
        fileList:[],
        cTitle:'',
        cContent:'',
        ruleForm:{
          // selecteddepartOption:[],
          theTitle:'',
          types:'',
          textarea:'',
          name:'',

          phone:'',
          verifyCode:'',
          smsCode:'',
        },
        rules:{
          selectedRegions:[{required:true,validator:this.checkDepartId,tigger:'blur'}],
          // selecteddepartOption:[{required:true,message:'请选择单位',tigger:'change'}],
          types:[{required:true,message:'请选择类别',tigger:'change'}],
          theTitle:[{required:true,message:'请输入标题',tigger:'blur'}],
          textarea:[{required:true,message:'请输入内容',tigger:'blur'}],
          name:[{required:true,message:'请输入姓名',tigger:'blur'}],
          phone:[{required:true ,validator:this.checkPhoneNumber,tigger:'blur'}],
          verifyCode:[{required:true ,message:'请输入验证码',tigger:'blur'}],
          smsCode:[{required:true ,message:'请输入短信验证码',tigger:'blur'}]
        },
        dialogImageUrl: '',
        dialogVisible: false,
        active: 'suggests',
        adviceType:"",
        serviceUnit:"",
        pictureList:[],
        fileIds:[],
        navTitle:"",
        type:"",
        applyId:"",
        partyId:'',
        partyYes:true,
        selectedRegion:[],
        departOption:[],
        vImg:'',
        uuid:'',
        props: {
          lazy: true,
          checkStrictly:false,
          lazyLoad (node, resolve) { const { level } = node;
            var t=0;
            if(!node.value){
              node.value=_self.$cookies.get("areaRoot");
              t=1;
              //上级为空，默认设置大通县数据
            }
            const options={pid:node.value}
            _self.$https.post("api/pu/getAreaByParentCode.do",options,response=>{
              const nodes =[];
              // if(t==0) {
              //   if(node.value=='63010001'){
              //     const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 3}];
              //     resolve(nodes);
              //   }else{
                  if (response.status === 200 && response.data.code === 200) {
                    const nodes = Object.values(response.data.data).map(function (e) {
                      return {label: e.name, value: e.code, level: 0, leaf: level >= 3}
                    })
                    resolve(nodes);
                  } else {
                    resolve(nodes);
                  }
                // }
              // }else{
              //   // const nodes =[{label:'大通县',value:'6301210001',level:0, leaf: level >= 2}];
              //   // resolve(nodes);
              //   const nodes =[{label:'西宁市',value:'63010001',level:0, leaf: level >= 2}];
              //   resolve(nodes);
              // }
            })
          }
        },
        needType:'',
        source:'',
        smsText:'发送短信',
        smsIsDisabled:true,
      }
    } ,

    watch: {
      width(n, o) {
        alert(n + 'w')
      },
      height(n, o) {
        alert(n + 'h')
      },
      // selectedRegion(nv) {
      //   this.getDepartAreas(nv[nv.length - 1], 0);
      // },
      '$route': function (to, from) {
        // 拿到目标参数 to.query.id 去再次请求数据接口
        this.type=to.query.type;
        this.navTitle=to.query.title;
        this.applyId=to.query.applyId;
        this.partyId=to.query.partyId;
        this.source=to.query.source+"";

        // this.ruleForm.selecteddepartOption=[];
        this.ruleForm.theTitle='';
          this.ruleForm.types='';
          this.ruleForm.textarea='';
          this.ruleForm.name='';
          this.ruleForm.phone='';
          this.ruleForm.verifyCode='';
          this.ruleForm.smsCode='';
          this.dialogImageUrl='';
          this.pictureList=[];
          this.fileIds=[];
        this.initDatas();
      },
    },
    created(){
      // this.showClause=false;
      // this.initClause();
      //建议类别枚举
      this.type=this.$route.query.type;
      this.navTitle=this.$route.query.title;
      if ("建议"===this.navTitle){
        this.tempTitle="我要建议"
      }else {
        this.tempTitle="意见反馈"
      }
      this.applyId=this.$route.query.applyId;
      this.partyId=this.$route.query.partyId;
      this.source=this.$route.query.source+"";
      this.initDatas();
      this.countDown();
      var userInfo=this.$cookies.get('userInfo')
      if(userInfo && userInfo.userId !='' && userInfo.userId !=-1){
       this.initPerson();
      }
      this.browseLog("ygjd","wyjy");
    },
    methods: {
      initPerson(){
        var tttt=this;
        this.$https.post("api/pu/peopleUserInfo.do",{},response=>{
          if (response.status === 200 && response.data.code===200) {
            if(response.data.data && response.data.data.isCertification && response.data.data.isCertification=='1'){
              tttt.ruleForm.name=response.data.data.userName;
              tttt.ruleForm.phone=response.data.data.userTel;
            }
          }
        })
      },
      browseLog(one,two){
        const options={
          oneCode:one,
          twoCode:two,
        }
        this.$https.post("api/browse/saveBrowseLog.do",options,response=>{
        })
      },
      onSelectedRegion(v){
        if(this.selectedRegion && this.selectedRegion.length>0){
          this.partyId=this.selectedRegion[this.selectedRegion.length-1];
        }else{
          this.partyId="";
        }

      },
      clauseClose(){
      this.showClause=false;
      },
      initClause(){
        this.$https.get("api/pu/clause/getClauseContentByType.do",{cType:'SUGGEST'},response=>{
          if (response.status === 200 && response.data.code===200) {
            this.cTitle=response.data.data.cTitle;
            this.cContent=response.data.data.cContent;
          } else {

          }
        })
        this.clauseShow=true;
      },
      countDown(times){
        var time;
        if(times){
          time=times;
        }else{
          time=this.$cookies.get("time2")
          if(!time){
            this.smsIsDisabled=false;
            return;
          }
        }
        time=time-1;
        this.$cookies.set("time2",time,time+"s")
        if(time<=0){
          this.smsIsDisabled=false;
          this.smsText="发送短信";
          this.$cookies.remove("time2")
          return
        }else{
          this.smsText=time+"秒"
          var t=this;
          setTimeout(function() {
            t.countDown(time);
          },1000)
        }

      },
      handleDialogClose() {
        this.urlTo('suggestIndex')
      },
      getSmsCode() {
        this.smsIsDisabled=true;
        if(this.ruleForm.phone==''){
          this.$message.error("请输入联系电话");
          this.smsIsDisabled=false;
          return false;
        }
        //校验联系电话码格式
        let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
        if (!myreg.test(this.ruleForm.phone)) {
          this.$message.error("请输入正确的联系电话");
          this.smsIsDisabled=false;
          return;
        }
        this.$https.post("api/pu/getTelCode.do",{tel:this.ruleForm.phone},response=>{
          if (response.status === 200 && response.data.code===200) {
            this.$message.success("短信校验码发送成功，10分钟内有效");
            //倒计时
            this.countDown(120);
          } else {
            this.smsIsDisabled=false;
            this.$message.error(response.data.msg);
          }
        })
      },
      initDatas(){
        const options={type:this.type}
        this.$https.post("api/suggest/getAdviceType.do",options,response=>{
          if (response.status === 200 && response.data.code===200) {
            this.adviceType=response.data.data;
          } else {
            this.adviceType =[];
          }
        })
        //区划id
        if(this.partyId){
          this.partyYes=false;
        }else{
          this.initArea();
        }
        var uuid=this.$cookies.get("uuid2");
        if(uuid == null || uuid==''){
          uuid="vc_"+this.$util.uuid.uuid2();
        }
        this.uuid=uuid;
        this.$cookies.set("uuid2",uuid,"3D");
        // this.getVerifyCode();
      },
      deleteone(file) {
        this.fileIds.remove(file.raw.attrId);
        return true;
      },
      beforeUpload(file){
        if(file.size>10485760) {
          this.$alert('文件大小不能超过10M', '提示', {
            confirmButtonText: '确定'
          });
          return false;
        }
        return true;
      },
      afterReadOne(files) {
        if (files) {
          files.status = 'uploading';
          files.message = '上传中...';
          files.type = 'suggest_' + this.suggestId;
          this.afterReadFile(files);
        }
      },
      afterReadFile(file) {
        var loading = this.$loading({
          lock: true,
          text: '数据处理中,请耐心等待....',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        file.status = 'uploading';
        let formData = new FormData;
        formData.append('_sk', 'app');
        formData.append('upload', file.file);
        formData.append('type', file.type);
        formData.append('attachName', this.$util.uuid.uuid2());
        var ttt = this;
        this.$https.postFile('attach/upload.do', formData, (response) => {
          if (response.status === 200 && response.data.isOk) {
            // file.attachId=response.data.bean.attach_id;
            ttt.fileIds.push(response.data.bean.attach_id);
            file.status = 'done';
            file.file.attrId = response.data.bean.attach_id
            // file.uid = response.data.bean.attach_id
          } else {
            file.status = 'failed';
          }
          loading.close();
        });
        //重新验证表单项
        // this.$refs['photo'].resetValidation();
      },
      urlTo(url, params) {
        this.$router.push({path: url, query: params || {}});
      },
      // getDepartAreas(ParentId, index) {
      //   this.ruleForm.selecteddepartOption=''
      //   const options = {pid: ParentId}
      //   var t = this;
      //   this.$https.post("api/pu/getPartyByParentAreaCode.do", options, response => {
      //     if (response.status === 200 && response.data.code === 200) {
      //       t.departOption = Object.values(response.data.data).map(function (e) {
      //         return {label: e.name, value: e.code}
      //       })
      //     } else {
      //       t.departOption = [];
      //     }
      //   })
      // },
      // getVerifyCode() {
      //   this.vImg = process.env.API_HOST + '/api/verifyCode_ajax.do?t=' + Math.random() + "&uuid=" + this.uuid;
      // },
      checkPhoneNumber(rule, value, callback) {
        const reg = /^1[3|4|5|6|7|8|9]\d{9}$/;
        if (!value) {
          return callback(new Error('请填写联系电话！'))
        } else if (!reg.test(value)) {
          return callback(new Error('请填写正确的联系电话！'))
        }else{
          callback()
        }
      },
      checkDepartId(rule,value,callback){
        if(!this.selectedRegion || this.selectedRegion.length<=0){
          return callback(new Error('请选择受理单位！'))
        }
        return  callback()
      },
      save() {
        this.disableds=true;
        var tt=this;
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            var _fileIds = "";
            if (tt.fileIds.length > 0) {
              _fileIds = tt.fileIds.toString();
            }
            // if (tt.partyId) {
            //   tt.ruleForm.selecteddepartOption = tt.partyId;
            // }
            const options = {
              people_name: tt.ruleForm.name,
              people_tel: tt.ruleForm.phone,
              adviceType: tt.type,
              fileIds: _fileIds,
              uuid:tt.uuid,
              // verifyCode:tt.ruleForm.verifyCode,
              selectOption: tt.partyId,
              theTitle: tt.ruleForm.theTitle,
              applyId: tt.applyId,
              textarea: tt.ruleForm.textarea,
              souce_type:tt.source,
              types:tt.ruleForm.types,
              es_source:'3',
              smsCode:tt.ruleForm.smsCode,
            };
            //把最新的状态发给服务端
            tt.$https.post('api/suggest/getAdviceSave.do', options, response => {
              if (response.data.code === 205) {
                tt.$message.error(response.data.msg);
                this.disableds=false;
              } else if (response.data.code === 200) {
                var userId=tt.$cookies.get('userId')
                if(userId && userId !='' && userId!='-1'){
                  tt.$alert('感谢您的反馈，我们会及时处理！<br />您可以通过:【个人中心->我的'+tt.navTitle+'】查看受理情况',"提交成功", {
                    confirmButtonText: '确定',
                    dangerouslyUseHTMLString:true,
                    callback: action => {
                      tt.$router.push('/home');
                      }
                  });
                }else{
                  tt.$alert('感谢您的反馈，我们会及时处理！',"提交成功", {
                    confirmButtonText: '确定',
                    callback: action => {
                      tt.$router.push('/home');
                    }
                  });
                }
                // tt.getVerifyCode()
              }  else if (response.data.code === 202) {
                tt.$message.error(response.data.msg);
                // tt.ruleForm.verifyCode='',
                //   tt.getVerifyCode();
                tt.disableds=false;
              } else if (response.data.code === 20201) {
                tt.$message.error(response.data.msg);
                // tt.getVerifyCode();
                // tt.ruleForm.verifyCode='',
                  tt.disableds=false;
              }else if (response.data.code === 203) {
                tt.$message.error(response.data.msg);
                // tt.ruleForm.verifyCode='',
                //   tt.getVerifyCode();
                  tt.ruleForm.smsCode='',
                    tt.disableds=false;
              }else if (response.data.code === 20301) {
                tt.$message.error(response.data.msg);
                // tt.ruleForm.verifyCode='',
                  tt.ruleForm.smsCode='',
                  // tt.getVerifyCode();
                tt.disableds=false;
              }else {
                tt.$message.error('提交失败');
                // tt.getVerifyCode();
                tt.disableds=false;
              }
            })
          } else {
            tt.disableds=false;
            return false;
          }
        });
      },
      goBack(){
        this.$router.back();
      },
      initArea(){
        var areaInfo=this.$cookies.get('areaInfo')
        if(areaInfo && areaInfo.departyId && areaInfo.departyId.length>0){
          this.selectedRegion=areaInfo.departyId;
          this.partyId=areaInfo.departyId[areaInfo.departyId.length-1]
          // if(areaInfo.provinceId){
          //   this.selectedRegion[0]=areaInfo.provinceId;
          // }
          // if(areaInfo.cityId){
          //   this.selectedRegion[1]=areaInfo.cityId;
          // }
          // if(areaInfo.areaId){
          //   this.selectedRegion[2]=areaInfo.areaId;
          // }
          // if(this.selectedRegion.length>0){
          //   this.getDepartAreas(this.selectedRegion[this.selectedRegion.length-1],0);
          // }
          // if(areaInfo.departyId){
          //   this.ruleForm.selecteddepartOption=areaInfo.departyId
          // }
        }
      }
    }
  }



</script>
<style>
</style>



// WEBPACK FOOTER //
// src/pages/suggest/Suggests.vue